<div class="editstate">
    <button
        class="badge"
        [ngClass]="getStatusColor(currentStatus())"
        [matMenuTriggerFor]="statusMenu"
        (click)="badgeClicked.emit(entity().id)"
    >
        {{ getTranslationKey(currentStatus()) | transloco }}
    </button>
</div>

<mat-menu
    #statusMenu="matMenu"
    xPosition="before"
    panelClass="state-badge-menu"
>
    @for (status of availableStatuses; track status) {
    <button
        mat-menu-item
        (click)="changeState(status)"
        [disabled]="currentStatus() === status"
    >
        <span
            class="status-dot"
            [ngClass]="getStatusColor(status)"
        ></span>
        {{ getTranslationKey(status) | transloco }}
    </button>
    }
</mat-menu>